// utils/draw/drawSplineFromCode.js
import * as THREE from 'three';
import { generateUniqueId } from '../utils/generateUniqueId';

export function drawSplineFromCode(target,  { points, color = 0xffffff, layerName = '0', opacity = 1.0 }) {
  if (  !Array.isArray(points) || points.length < 2) return;

  const curve = new THREE.CatmullRomCurve3(
    points.map((p) => new THREE.Vector3(p.x, p.y, p.z || 0))
  );

  const divisions = Math.max(10, points.length * 10);
  const splinePoints = curve.getPoints(divisions);
  const geometry = new THREE.BufferGeometry().setFromPoints(splinePoints);

  // ✅ Transparency desteği
  const materialOptions = { color };
  if (opacity < 1) {
    materialOptions.transparent = true;
    materialOptions.opacity = 1 - opacity;
  }
  const material = new THREE.LineBasicMaterial(materialOptions);
  const spline = new THREE.Line(geometry, material);

  spline.userData = {
    id: generateUniqueId('spline'),
    type: 'spline',
    controlPoints: points,
    splinePoints: splinePoints.map(p => ({x: p.x, y: p.y, z: p.z})),
    isSelectable: true,
    originalColor: color,
    layerName,
  };

//  scene.add(spline);
if (target) target.add(spline);
  return spline;
}


/*  KULLANIM 
  drawSplineFromCode(scene, {
      points: [
        { x: 0, y: 0 },
        { x: 100, y: 0 },
        { x: 100, y: 100 },
        { x: 0, y: 100 },
      ],
      color: 0x00ff00,
    });
    
    
    */